import Vue from 'vue'
import Vuex from 'vuex'
import Api from './services/api'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    key: null,
    news: [],
    answers: [],
    topics: [],
    scores: null,
    scoresSaved: null,
    verfiedInstructions: false,
    locale: 'en',
    topic: null
  },
  getters: {
    intructionsVerified: state => state.verfiedInstructions || $cookies.get('verified_instructions') || false,
    theKey: state => state.key,
    theNews: state => state.news,
    theTopics: state => state.topics,
    theLastNews: state => state.news.length ? state.news[state.news.length - 1] : null,
    theAnswers: state => state.answers,
    theScores: state => state.scores,
    theScoresSaved: state => state.scoresSaved,
    theLocale: state => state.locale,
    theTopic: state => state.topic
  },
  mutations: {
    SET_LOCALE: (state, locale) => {
      state.locale = locale
    },
    SET_TOPIC: (state, topicId) => {
      state.topic = topicId
    },
    GET_KEY: (state, key) => {
      state.key = key
    },
    GET_NEWS: (state, news) => {
      state.news.push(news)
    },
    GET_TOPICS: (state, topics) => {
      state.topics = topics
    },
    GET_ANSWERS: (state, answer) => {
      state.answers.push(answer)
    },
    GET_SCORE: (state, scores) => {
      state.scores = scores
    },
    GET_SCORES_SAVED: (state, scores) => {
      state.scoresSaved = scores
    },
    EMPTY_ALL: (state) => {
      state.key = null
      state.news = []
      state.answers = []
      state.scores = null
    },
    VERIFY_INSTRUCTIONS: (state) => {
      state.verifiedInstructions = true
    }
  },
  actions: {
    setTopic(context, topicId) {
      console.log('setting', topicId)
      context.commit('SET_TOPIC', topicId)
    },
    setLocale (context, locale) {
      context.commit('SET_LOCALE', locale)
    },
    emptyAll (context) {
      context.commit('EMPTY_ALL')
    },
    getKey (context) {
      return new Promise((resolve, reject) => {
        Api.post('credentials', {}, true).then(response => {
          if (response.success) {
            context.commit('GET_KEY', response.body.key)
            resolve(response.body)
          }
        }).catch(e => {
          reject(e)
        })
      })
    },
    getNews (context, data) {
      return new Promise((resolve, reject) => {
        Api.get('news?k=' + data.key + (data.lang === 'en' ? '&lang=' + data.lang : '') + (data.topic ? '&topic=' + data.topic : ''), true).then(response => {
          if (response.success) {
            console.log(response.body)
            context.commit('GET_NEWS', response.body)
            resolve(response.body)
          }
        }).catch(e => {
          reject(e)
        })
      })
    },
    getTopics (context, data) {
      return new Promise((resolve, reject) => {
        Api.get('topics' + (data.lang === 'en' ? '&lang=' + data.lang : ''), true).then(response => {
          if (response.success) {
            console.log(response.body)
            context.commit('GET_TOPICS', response.body)
            resolve(response.body)
          }
        }).catch(e => {
          reject(e)
        })
      })
    },
    ressolveNews (context, data) {
      return new Promise((resolve, reject) => {
        Api.post('news?k=' + data.key, {
          news: data.news,
          is_real: data.isReal
        }, true).then(response => {
          if (response.success) {
            // console.log(response.body)
            context.commit('GET_ANSWERS', response.body)
            resolve(response.body)
          }
        }).catch(e => {
          reject(e)
        })
      })
    },
    checkScore (context, data) {
      return new Promise((resolve, reject) => {
        Api.post('score?k=' + data.key, {
          score: data.score
        }, true).then(response => {
          if (response.success) {
            console.log(response.body)
            context.commit('GET_SCORE', response.body)
            resolve(response.body)
          }
        }).catch(e => {
          reject(e)
        })
      })
    },
    saveScore (context, data) {
      return new Promise((resolve, reject) => {
        Api.post('ranking?k=' + data.key, {
          score: data.score,
          name: data.name
        }, true).then(response => {
          if (response.success) {
            console.log(response.body)
            context.commit('GET_SCORES_SAVED', response.body)
            resolve(response.body)
          }
        }).catch(e => {
          reject(e)
        })
      })
    }
  }
})
